import { forwardRef } from "react";

import {
  // Austrian banks
  IconAddikoSmallLogo,
  IconAerzteApothekerbankSmallLogo,
  IconAirbankSmallLogo,
  IconAliorBankLogo,
  IconAnadiSmallLogo,
  IconArgentexSmallLogo,
  IconBank365Logo,
  IconBank99SmallLogo,
  IconBankPekaoLogo,
  IconBankAustriaSmallLogo,
  IconBankAustriaUnicreditSmallLogo,
  IconBankBurgenlandSmallLogo,
  IconBankWinterSmallLogo,
  IconBankhausSchelhammerSmallLogo,
  IconBankhausSpanglerSmallLogo,
  IconBawagSmallLogo,
  IconBcSmallLogo,
  IconBksSmallLogo,
  IconBtvSmallLogo,
  IconCommerzbankLogo,
  IconConsorsFinanzSmallLogo,
  IconCreditasSmallLogo,
  IconCsasSmallLogo,
  IconCsobSmallLogo,
  IconDeutscheBankLogo,
  IconDolomitenSmallLogo,
  IconEasybankSmallLogo,
  IconEdbSmallLogo,
  IconErsteSmallLogo,
  IconFioSmallLogo,
  IconFrankfurterVolksbankLogo,
  IconGeneraliSmallLogo,
  IconHypoNoeSmallLogo,
  IconHypoTirolSmallLogo,
  IconHypovereinsbankLogo,
  IconHypoVorarlbergSmallLogo,
  IconIngLogo,
  IconJTBankSmallLogo,
  IconJuniSmallLogo,
  IconKbSmallLogo,
  IconMarchfelderSmallLogo,
  IconMbankSmallLogo,
  IconMillenniumLogo,
  IconMonetaSmallLogo,
  IconN26SmallLogo,
  IconOberbankSmallLogo,
  IconPaypalSmallLogo,
  IconPkoBpLogo,
  IconPostbankLogo,
  IconQontoLogo,
  IconRbSmallLogo,
  IconRevolutSmallLogo,
  IconSchoellerbankSmallLogo,
  IconSlovenskaSporitelnaLogo,
  IconSpardaSmallLogo,
  IconSwanSmallLogo,
  IconTatraBankaLogo,
  IconUnicreditSmallLogo,
  IconVolksbankKaerntenSmallLogo,
  IconVolksbankNoeSmallLogo,
  IconVolksbankOoeSmallLogo,
  IconVolksbankSalzburgSmallLogo,
  IconVolksbankSteiermarkSmallLogo,
  IconVolksbankTirolSmallLogo,
  IconVolksbankVorarlbergSmallLogo,
  IconVolksbankWienSmallLogo,
  IconVrBankSmallLogo,
  IconVubLogo,
  IconWamoSmallLogo,
  IconWiseSmallLogo,
  IconBnpParibasLogo,
  IconCitiHandlowyLogo,
  IconHsbcLogo,
  IconLbbwLogo,
  IconSparkasseLogo,
} from "@dfp/react-bank-logos";
import { IconBank } from "@dfp/react-icons";

import { AppAvatar, type AppAvatarProps } from "./AppAvatar.tsx";

export const bankAvatarLogoMap = {
  "Fio banka, a.s.": IconFioSmallLogo,
  Fio: IconFioSmallLogo,
  FIO: IconFioSmallLogo,
  FIOBCZPP: IconFioSmallLogo,
  FIOBCZPPXXX: IconFioSmallLogo,
  "Komerční banka, a.s.": IconKbSmallLogo,
  KB: IconKbSmallLogo,
  KOMBCZPPXXX: IconKbSmallLogo,
  KOMBCZPP: IconKbSmallLogo,
  "Air Bank a.s.": IconAirbankSmallLogo,
  AIRBANK: IconAirbankSmallLogo,
  AIRACZPP: IconAirbankSmallLogo,
  AIRACZPPXXX: IconAirbankSmallLogo,
  "Banka CREDITAS a.s.": IconCreditasSmallLogo,
  CREDITAS: IconCreditasSmallLogo,
  CTASCZ22XXX: IconCreditasSmallLogo,
  CTASCZ22: IconCreditasSmallLogo,
  "Česká spořitelna, a.s.": IconCsasSmallLogo,
  CSAS: IconCsasSmallLogo,
  GIBACZPXXXX: IconCsasSmallLogo,
  GIBACZPX: IconCsasSmallLogo,
  "ČSOB, a.s.": IconCsobSmallLogo,
  CSOB: IconCsobSmallLogo,
  CEKOCZPP: IconCsobSmallLogo,
  CEKOCZPPXXX: IconCsobSmallLogo,
  "J&T BANKA, a.s.": IconJTBankSmallLogo,
  JTB: IconJTBankSmallLogo,
  JTBPCZPPXXX: IconJTBankSmallLogo,
  JTBPCZPP: IconJTBankSmallLogo,
  "mBank S.A., organizační složka": IconMbankSmallLogo,
  MBANK: IconMbankSmallLogo,
  BREXCZPPXXX: IconMbankSmallLogo,
  BREXCZPP: IconMbankSmallLogo,
  BREXSKBX: IconMbankSmallLogo,
  BREXPLPW: IconMbankSmallLogo,
  CEKOSKBX: IconCsobSmallLogo,
  // Slovak banks
  GIBASKBX: IconSlovenskaSporitelnaLogo,
  TATRSKBX: IconTatraBankaLogo,
  SUBASKBX: IconVubLogo,
  POBNSKBA: IconBank365Logo,
  // Polish banks
  ALBPPLPW: IconAliorBankLogo,
  PKOPPLPW: IconBankPekaoLogo,
  BPKOPLPW: IconPkoBpLogo,
  BIGBPLPW: IconMillenniumLogo,
  INGBPLPW: IconIngLogo,
  // German banks
  DEUTDEFF: IconDeutscheBankLogo,
  COBADEFF: IconCommerzbankLogo,
  FFVBDEFF: IconFrankfurterVolksbankLogo,
  HYVEDEMM: IconHypovereinsbankLogo,
  PBNKDEFF: IconPostbankLogo,
  QNTODEB2: IconQontoLogo,
  "MONETA Money Bank, a.s.": IconMonetaSmallLogo,
  MONETA: IconMonetaSmallLogo,
  AGBACZPPXXX: IconMonetaSmallLogo,
  AGBACZPP: IconMonetaSmallLogo,
  "Raiffeisenbank, a.s.": IconRbSmallLogo,
  RAIFFEISEN: IconRbSmallLogo,
  RZBCCZPPXXX: IconRbSmallLogo,
  RZBCCZPP: IconRbSmallLogo,
  "UniCredit Bank Czech Republic and Slovakia, a.s.": IconUnicreditSmallLogo,
  UNICREDIT: IconUnicreditSmallLogo,
  BACXCZPPXXX: IconUnicreditSmallLogo,
  BACXCZPP: IconUnicreditSmallLogo,
  // Mockup
  "Banking Circle SA": IconBcSmallLogo,
  BC: IconBcSmallLogo,
  // Austrian banks — provider values
  argentex_oauth_client_at: IconArgentexSmallLogo,
  btv_client_at: IconBtvSmallLogo,
  oberbank_client_at: IconOberbankSmallLogo,
  bks_client_at: IconBksSmallLogo,
  consors_finanz_client_at: IconConsorsFinanzSmallLogo,
  addiko_bank_oauth_client_at: IconAddikoSmallLogo,
  anadi_bank_oauth_client_at: IconAnadiSmallLogo,
  bawag_psk_oauth_client_at: IconBawagSmallLogo,
  easybank_oauth_client_at: IconEasybankSmallLogo,
  sparda_oauth_client_at: IconSpardaSmallLogo,
  bank_99_oauth_client_at: IconBank99SmallLogo,
  bank_burgenland_oauth_client_at: IconBankBurgenlandSmallLogo,
  bank_winter_oauth_client_at: IconBankWinterSmallLogo,
  bankhaus_spangler_oauth_client_at: IconBankhausSpanglerSmallLogo,
  erste_bank_sparkassen_oauth_client_at: IconErsteSmallLogo,
  edb_oauth_client_at: IconEdbSmallLogo,
  generali_bank_oauth_client_at: IconGeneraliSmallLogo,
  hypo_noe_oauth_client_at: IconHypoNoeSmallLogo,
  hypo_tirol_oauth_client_at: IconHypoTirolSmallLogo,
  hypo_vorarlberg_oauth_client_at: IconHypoVorarlbergSmallLogo,
  juni_oauth_client_at: IconJuniSmallLogo,
  n26_xs2a_oauth_client_at: IconN26SmallLogo,
  paypal_oauth_client_at: IconPaypalSmallLogo,
  raiffeisen_client_at: IconRbSmallLogo,
  revolut_oauth_client_at: IconRevolutSmallLogo,
  swan_oauth_client_at: IconSwanSmallLogo,
  schoellerbank_oauth_client_at: IconSchoellerbankSmallLogo,
  unicredit_business_oauth_client_at: IconBankAustriaUnicreditSmallLogo,
  unicredit_oauth_client_at: IconBankAustriaUnicreditSmallLogo,
  vr_bank_rottal_inn_eg_oauth_client_at: IconVrBankSmallLogo,
  volksbank_niederosterreich_oauth_client_at: IconVolksbankNoeSmallLogo,
  volksbank_oberosterreich_oauth_client_at: IconVolksbankOoeSmallLogo,
  volksbank_salzburg_oauth_client_at: IconVolksbankSalzburgSmallLogo,
  volksbank_steiermark_oauth_client_at: IconVolksbankSteiermarkSmallLogo,
  volksbank_tirol_oauth_client_at: IconVolksbankTirolSmallLogo,
  volksbank_vorarlberg_oauth_client_at: IconVolksbankVorarlbergSmallLogo,
  volksbank_kaernten_oauth_client_at: IconVolksbankKaerntenSmallLogo,
  dolomiten_bank_oauth_client_at: IconDolomitenSmallLogo,
  marchfelder_bank_oauth_client_at: IconMarchfelderSmallLogo,
  osterreichische_arzte_und_apothekerbank_oauth_client_at:
    IconAerzteApothekerbankSmallLogo,
  wamo_oauth_client_at: IconWamoSmallLogo,
  transferwise_oauth_client_at: IconWiseSmallLogo,
  // Austrian banks — BIC codes
  Argentex: IconArgentexSmallLogo,
  ARTXGB2L: IconArgentexSmallLogo,
  ARTXGB2LXXX: IconArgentexSmallLogo,
  "Bank 99": IconBank99SmallLogo,
  BTVAAT22: IconBtvSmallLogo,
  BTVAAT22XXX: IconBtvSmallLogo,
  OBKLAT2L: IconOberbankSmallLogo,
  OBKLAT2LXXX: IconOberbankSmallLogo,
  BFKKAT2K: IconBksSmallLogo,
  BFKKAT2KXXX: IconBksSmallLogo,
  GEBAATWW: IconConsorsFinanzSmallLogo,
  GEBAATWWXXX: IconConsorsFinanzSmallLogo,
  HSEEAT2K: IconAddikoSmallLogo,
  HSEEAT2KXXX: IconAddikoSmallLogo,
  HAABAT2K: IconAnadiSmallLogo,
  HAABAT2KXXX: IconAnadiSmallLogo,
  BAWAATWW: IconBawagSmallLogo,
  BAWAATWWXXX: IconBawagSmallLogo,
  EASYATW1: IconEasybankSmallLogo,
  EASYATW1XXX: IconEasybankSmallLogo,
  SPDAAT21: IconSpardaSmallLogo,
  SPDAAT21XXX: IconSpardaSmallLogo,
  EHBBAT2E: IconBankBurgenlandSmallLogo,
  EHBBAT2EXXX: IconBankBurgenlandSmallLogo,
  WISMATWW: IconBankWinterSmallLogo,
  WISMATWWXXX: IconBankWinterSmallLogo,
  BSSWATWW: IconBankhausSchelhammerSmallLogo,
  BSSWATWWXXX: IconBankhausSchelhammerSmallLogo,
  SPAEAT2S: IconBankhausSpanglerSmallLogo,
  SPAEAT2SXXX: IconBankhausSpanglerSmallLogo,
  GIBAATWW: IconErsteSmallLogo,
  GIBAATWWXXX: IconErsteSmallLogo,
  EDBKATWW: IconEdbSmallLogo,
  EDBKATWWXXX: IconEdbSmallLogo,
  BGENATWW: IconGeneraliSmallLogo,
  BGENATWWXXX: IconGeneraliSmallLogo,
  HYPNATWW: IconHypoNoeSmallLogo,
  HYPNATWWXXX: IconHypoNoeSmallLogo,
  HYPTAT22: IconHypoTirolSmallLogo,
  HYPTAT22XXX: IconHypoTirolSmallLogo,
  HYPVAT2B: IconHypoVorarlbergSmallLogo,
  HYPVAT2BXXX: IconHypoVorarlbergSmallLogo,
  DABAIE2D: IconJuniSmallLogo,
  DABAIE2DXXX: IconJuniSmallLogo,
  NTSBDEB1: IconN26SmallLogo,
  NTSBDEB1XXX: IconN26SmallLogo,
  PPLXLUL2: IconPaypalSmallLogo,
  PPLXLUL2XXX: IconPaypalSmallLogo,
  RZBAATWW: IconRbSmallLogo,
  RZBAATWWXXX: IconRbSmallLogo,
  REVOLT21: IconRevolutSmallLogo,
  REVOLT21XXX: IconRevolutSmallLogo,
  SWNQFR21: IconSwanSmallLogo,
  SWNQFR21XXX: IconSwanSmallLogo,
  SCHOATWW: IconSchoellerbankSmallLogo,
  SCHOATWWXXX: IconSchoellerbankSmallLogo,
  BKAUATWW: IconBankAustriaSmallLogo,
  BKAUATWWXXX: IconBankAustriaSmallLogo,
  CAIBATWW: IconBankAustriaUnicreditSmallLogo,
  CAIBATWWXXX: IconBankAustriaUnicreditSmallLogo,
  VRBKAT21: IconVrBankSmallLogo,
  VRBKAT21XXX: IconVrBankSmallLogo,
  VBOEAT2WWNOM: IconVolksbankNoeSmallLogo,
  VBWEAT2W: IconVolksbankOoeSmallLogo,
  VBWEAT2WXXX: IconVolksbankOoeSmallLogo,
  VBOEAT2WWSAL: IconVolksbankSalzburgSmallLogo,
  VBOEATWWGRA: IconVolksbankSteiermarkSmallLogo,
  VBOEATWBINN: IconVolksbankTirolSmallLogo,
  VOVBAT2B: IconVolksbankVorarlbergSmallLogo,
  VOVBAT2BXXX: IconVolksbankVorarlbergSmallLogo,
  VBOEATWW: IconVolksbankWienSmallLogo,
  VBOEATWWKLA: IconVolksbankKaerntenSmallLogo,
  OVLIAT21: IconDolomitenSmallLogo,
  OVLIAT21XXX: IconDolomitenSmallLogo,
  MVOGAT22: IconMarchfelderSmallLogo,
  MVOGAT22XXX: IconMarchfelderSmallLogo,
  BWFBATW1: IconAerzteApothekerbankSmallLogo,
  BWFBATW1XXX: IconAerzteApothekerbankSmallLogo,
  WAMOFRPP: IconWamoSmallLogo,
  WAMOFRPPXXX: IconWamoSmallLogo,
  TRWIBEB1: IconWiseSmallLogo,
  TRWIBEB1XXX: IconWiseSmallLogo,
  // BIC values exactly as paymentProviderEnum spells them
  VBOEATWWNOM: IconVolksbankNoeSmallLogo,
  VBOEATWWOOE: IconVolksbankOoeSmallLogo,
  VBOEATWWSAL: IconVolksbankSalzburgSmallLogo,
  VBOEATWWINN: IconVolksbankTirolSmallLogo,
  VBOEATWWXXX: IconVolksbankWienSmallLogo,
  SPBAATWWXXX: IconBank99SmallLogo,
  TRWIBEBB: IconWiseSmallLogo,
  INGBCZPP: IconIngLogo,
  INGBCZPPXXX: IconIngLogo,
  INGDDEFF: IconIngLogo,
  BBRUBEBBXXX: IconIngLogo,
  INGBNL2AXXX: IconIngLogo,
  INGBROBUXXX: IconIngLogo,
  UNCRSKBX: IconUnicreditSmallLogo,
  BACXHUHBXXX: IconUnicreditSmallLogo,
  UNCRITMMXXX: IconUnicreditSmallLogo,
  BACXROBUXXX: IconUnicreditSmallLogo,
  BACXSI22XXX: IconUnicreditSmallLogo,
  UNCRBGSFXXX: IconUnicreditSmallLogo,
  UBRTHUHBXXX: IconRbSmallLogo,
  RZBHHR2XXXX: IconRbSmallLogo,
  RZBRROBUXXX: IconRbSmallLogo,
  GIBAHUHBXXX: IconErsteSmallLogo,
  ESBCHR22XXX: IconErsteSmallLogo,
  WBKPPLPP: IconErsteSmallLogo,
  FIOZSKBA: IconFioSmallLogo,
  KOMBSKBA: IconKbSmallLogo,
  QNTOFRP1XXX: IconQontoLogo,
  REVONL22XXX: IconRevolutSmallLogo,
  REVOROBBXXX: IconRevolutSmallLogo,
  OBKLCZ2XXXX: IconOberbankSmallLogo,
  HAABSI22XXX: IconAddikoSmallLogo,
  MIDLCZPP: IconHsbcLogo,
  MIDLCZPPXXX: IconHsbcLogo,
  GEBACZPP: IconBnpParibasLogo,
  GEBACZPPXXX: IconBnpParibasLogo,
  PPABPLPK: IconBnpParibasLogo,
  CITIPLPX: IconCitiHandlowyLogo,
  SOLADEST: IconLbbwLogo,
  WELADED1GRL: IconSparkasseLogo,
  BNPAFRPPXXX: IconBnpParibasLogo,
  GEBABEBBXXX: IconBnpParibasLogo,
  ZABAHR2XXXX: IconUnicreditSmallLogo,
  KSPKSI22XXX: IconSparkasseLogo,
};

export type BankKeys = keyof typeof bankAvatarLogoMap;

export type BankAvatarProps = {
  bank: string | BankKeys;
} & Omit<AppAvatarProps, "children" | "src">;

const isKeyValid = <T extends object>(
  obj: T,
  key: string | number | symbol,
): key is keyof T => key in obj;

export const BankAvatar = forwardRef<HTMLDivElement, BankAvatarProps>(
  function BankAvatar({ bank, size = 24, sx, ...rest }, ref) {
    const selectedBank = isKeyValid(bankAvatarLogoMap, bank)
      ? bankAvatarLogoMap[bank]
      : null;
    const Logo = selectedBank ?? IconBank;
    const fallbackSize = size / 1.75;

    return (
      <AppAvatar
        {...rest}
        ref={ref}
        size={size}
        sx={[
          (theme) => ({
            outline: "none",
            ...(selectedBank && {
              backgroundColor: theme.palette.background.paper,
              outline: `1px solid ${theme.palette.custom.borderImage}`,
            }),
          }),
          ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        ]}
      >
        <Logo
          width={selectedBank ? size : fallbackSize}
          height={selectedBank ? size : fallbackSize}
        />
      </AppAvatar>
    );
  },
);
